/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var EmailType;
(function (EmailType) {
    EmailType["PERSONAL"] = "personal";
    EmailType["PROFESSIONAL"] = "professional";
})(EmailType || (EmailType = {}));
